import { createContext, useState, ReactNode } from 'react';

interface DesktopPushNotificationDialogContextType {
  shouldShowDesktopDialog: boolean;
  showDesktopDialog: () => void;
  closeDesktopDialog: () => void;
}

const defaultContext: DesktopPushNotificationDialogContextType = {
  shouldShowDesktopDialog: false,
  showDesktopDialog: () => {},
  closeDesktopDialog: () => {},
};

export const DesktopPushNotificationDialogContext =
  createContext<DesktopPushNotificationDialogContextType>(defaultContext);

export function DesktopPushNotificationDialogProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [shouldShowDesktopDialog, setShouldShowDesktopDialog] = useState(false);

  const showDesktopDialog = () => setShouldShowDesktopDialog(true);
  const closeDesktopDialog = () => setShouldShowDesktopDialog(false);

  return (
    <DesktopPushNotificationDialogContext.Provider
      value={{
        shouldShowDesktopDialog,
        showDesktopDialog,
        closeDesktopDialog,
      }}
    >
      {children}
    </DesktopPushNotificationDialogContext.Provider>
  );
}
